import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import StatsMarquee from './components/StatsMarquee';
import Principles from './components/Principles';
import PillarShowcase from './components/PillarShowcase';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 150);
    }
  }, [location.hash]);

  return (
    <div className="bg-background-50 text-white">
      <Navbar transparent />
      <main>
        <Hero />
        <StatsMarquee />
        <Principles />
        <PillarShowcase />
      </main>
      <Footer />
    </div>
  );
}